import React, {useState} from "react";
import styled from 'styled-components';
import {Link} from "react-router-dom";
import { useHistory } from 'react-router-dom'

const SideBarLink=styled.div`
  display: flex;
  color: #e1e9fc;
  align-items: center;
  padding: 15px;
  list-style: none;
  height: 60px;
  text-decoration: none;
  font-size: 18px;
  justify-content: ${({isOpened}) => (isOpened ? 'left' : 'center')};
  user-select: none;
  transition: 400ms;

  &:hover {
    background: #252831;
    border-left: 1px solid #425e68;
    cursor: pointer;
    transition: 400ms;
  }
`;

const SideBarLabel=styled.span`
	margin-left: 16px;
`;

const DropdownLink=styled(Link)`
  background: #4e4f5a;
 
  height: 60px;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  text-decoration: none;
  color: #f5f5f5;
  font-size: 18px;
  transition: 400ms;
  user-select: none;

  &:hover {
    background: #425e68;
    cursor: pointer;
    transition: 400ms;
  }
`;

export default function SubMenu({item,key,isOpened, closeMenu}){
	console.log(isOpened);

	const [subnav, setSubnav] = useState(false);
	const { push } = useHistory();

	const showSubnav = ()=>{
		if(isOpened) {
			setSubnav(!subnav);
		}
	}

	const goToPage=()=>{
		//window.location.href=item.path;
		push(item.path);
	}


	return(
		<div>
			<SideBarLink onClick={isOpened?(item.suby&&showSubnav):goToPage}>
				<div>
					{item.ikonka}
					{isOpened?<SideBarLabel>
						{item.tytul}
					</SideBarLabel>:null}
				</div>
				<div>
					{isOpened?(item.subNav&&subnav?item.otwarta:item.suby?item.zamknieta:null):null}
				</div>
			</SideBarLink>
			{isOpened&&subnav&&item.suby.map((item, index)=>{
				return(
					<DropdownLink to={item.path} key={index} onClick={()=>closeMenu()}>
						{item.tytul}
					</DropdownLink>
				);
			})}
		</div>
	);
}